<lib-form-field-container
    [isOptional]="isOptionalOverride"
    [kind]="FormContainerKind.Checkbox">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>

    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            {{ formControl.value ? 'Selected' : 'Not selected' }}
        </div>
    </ng-container>
    <div class="sb-form-field-checkbox">
        @if (isLoading) {
            <div class="sb-form-field-checkbox-loading"></div>
        } @else {
            <mat-checkbox
                #checkbox
                [id]="formFieldID"
                                [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                                                [attr.aria-label]="ariaLabel || null"
                                                [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
                                [attr.aria-required]="formControl.isRequired"
                [formControl]="viewControl"
                [indeterminate]="isIndeterminate"
                [attr.data-sb-qa]="qaTag"
                (click)="$event.stopPropagation()"
                (change)="ChangeEvent($event)"></mat-checkbox>
        }
        <div
            class="sb-form-field-checkbox-wrapper"
            [class.cursor-pointer]="!formControl.disabled && !isLoading"
            (click)="!isLoading && SetValue(!viewControl.value)">
            <p [class.sb-form-field-text-skeleton]="isLoading"><ng-content></ng-content></p>
            <small
                #supportingText
                [hidden]="!isLoading && !supportingText.textContent"
                class="sb-form-field-checkbox-supporting-text">
                @if (isLoading) {
                    <div
                        #supportingTextContent
                        hidden>
                        <ng-container *ngTemplateOutlet="supportingTextTemplate"></ng-container>
                    </div>
                    @if (supportingTextContent.textContent) {
                        <div class="sb-form-field-text-skeleton sb-form-field-text-skeleton-sm"></div>
                    }
                } @else {
                    <ng-container *ngTemplateOutlet="supportingTextTemplate"></ng-container>
                }
            </small>
        </div>
    </div>
</lib-form-field-container>

<ng-template #supportingTextTemplate>
    <ng-content select="[checkboxSupportingText]"></ng-content>
</ng-template>
